module.exports = __webpack_public_path__ + "static/assets/ee83883bd8de7dbac7716b5b1dfa2ee5.jpg";